module.exports = __webpack_public_path__ + "static/brandbook-d1f016560fadd02dbe230838170aa125.svg";